/**
 * Part of [Canivete](http://canivete.leofavre.com/#deepgroupby)
 * 
 * Groups the contents of an array by one or more iteratees.
 * Unlike Lodash [`groupBy()`](https://lodash.com/docs/4.17.4#groupBy),
 * this function can create nested groups, but cannot receive
 * strings for iteratees.
 */
const deepGroupBy = (collection, ...iteratees) => {
	let paths = collection.map(value => iteratees.map(iteratee => iteratee(value))),
		result = {};

	paths.forEach((path, index) => {
		let currentValue = _simpleAt(result, path) || [],
			newValue = currentValue.concat([collection[index]]);

		_simpleSet(result, path, newValue);
	});

	return result;
};

const _isPlainObject = arg =>
    arg != null && typeof arg == "object" && arg.constructor == Object;

const _parsePath = path =>
    Array.isArray(path) ? path : `${path}`.split(".");

const _simpleAt = (obj, path) =>
    _parsePath(path).reduce((obj, key) => {
        return (obj != null && obj.hasOwnProperty(key)) ? obj[key] : undefined;
    }, obj);

const _simpleSet = (obj, path, value) =>
    _parsePath(path).reduce((obj, key, index, arr) => {
        let isLast = (index === arr.length - 1);

        if (!obj.hasOwnProperty(key) || (!isLast && !_isPlainObject(obj[key]))) {
            obj[key] = {};
        }

        return (!isLast) ? obj[key] : obj[key] = value;
    }, obj);

export default deepGroupBy;
